import axios from 'axios';
import { AUTH_URL } from '../../../vars';

/**
 * @namespace Auth
 * @description Авторизация (Page:/login)
 */
export default {
  state: {
    user: null,
    token: null,
  },
  mutations: {
    UPDATE_USER(state, data) {
      state.user = data;
    },
    UPDATE_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    /**
     * @property {Object} ctx Объект vuex
     * @property {Object} payload Содержит email и пароль
     * @return {Object} Объект с ошибкой или данными пользователя
     *
     * @memberof Auth
     */
    async AUTH(ctx, payload) {
      try {
        const { data } = await axios.post(`${AUTH_URL}login/`, payload);

        ctx.commit('UPDATE_TOKEN', data.token);
        localStorage.setItem('isLoggedIn', data.user);
        return data;
      } catch (e) {
        console.log(e);
        // messageHelper(e.detail, 'error', 6000, )
        throw e;
      }
    },
  },
  getters: {
    GETTERS_CURRENT_USER(state) {
      return state.user;
    },
    GETTERS_TOKEN(state) {
      return state.token;
    },
  },
};
